import { SelectableLink, SelectableLinkContainer } from 'components/Link';
import Modal from 'components/Modal';
import { TextStyle } from 'components/Text';
import { white } from 'core/styles';
import { getRandomItem } from 'core/utils/logic';
import { processText } from 'core/utils/string';
import { useNavigateHome } from 'hooks/navigation';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getIsModalOpen, setIsModalOpen } from 'reducer/modalState';
import { useToggleModalWithSound } from 'hooks/navigation';
import styled from 'styled-components';
import { desktop } from 'submodules/sharedText/flavor';

const { general, exitModal } = desktop;
const flavor = { ...general, ...exitModal };

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalContent = styled(TextStyle)`
  width: 70%;
  text-align: center;
  color: ${white};
`;

const ExitModal = ({ players, onExitGame }) => {
  const dispatch = useDispatch();
  const showModal = useSelector(getIsModalOpen);
  const toggleModal = useToggleModalWithSound();

  const navigateHome = useNavigateHome();

  const handleExit = () => {
    dispatch(setIsModalOpen(false));
    onExitGame();
    navigateHome();
  };

  return (
    <Modal isOpen={showModal}>
      <Wrapper>
        {players.length > 0 && (
          <ModalContent>
            {processText(flavor.waitingRoomPlayersInGame, {
              randomPlayer: getRandomItem(players).userName,
            })}
          </ModalContent>
        )}
        <SelectableLinkContainer stopKeyPress={!showModal} inModal>
          <SelectableLink onClick={toggleModal} inModal>
            {processText(flavor.cancel)}
          </SelectableLink>
          <SelectableLink onClick={handleExit} inModal>
            {processText(flavor.exit)}
          </SelectableLink>
        </SelectableLinkContainer>
      </Wrapper>
    </Modal>
  );
};
export default ExitModal;
